import el_GR from '../../date-picker/locale/el_GR';
export default el_GR;



// WEBPACK FOOTER //
// ./components/calendar/locale/el_GR.tsx